import React from 'react';
import ShortId from 'shortid';
import SocialNetworkLink from './../../components/social-network-link';

const ProfileSummary = ({ profile }) => (
  <div className="col-md-6" id="profile-information">
    <div className="row">
      <div className="col-md-12 text-md-center text-sm-center">
        <h2>{ profile.name }</h2>
        <span>{ profile.countryCode || '-' }</span>
      </div>
    </div>
    <div className="row">
      <div className="col-md-2 profile-label">Name</div>
      <div className="col-md-10 profile-value">{ profile.aka || profile.name }</div>
    </div>
    <div className="row">
      <div className="col-md-2 profile-label">Contact</div>
      <div className="col-md-10 profile-value">{ profile.contactEmail || '-' }</div>
    </div>
    <div className="row">
      <div className="col-md-2 profile-label">Links</div>
      <div className="col-md-10 profile-value">
        { profile.socialMediaChannelsOTF && profile.socialMediaChannelsOTF.map(channel =>
          <SocialNetworkLink
            key={ShortId.generate()}
            link={channel}
          />) }
      </div>
    </div>
    <div className="row">
      <div className="col-md-2 profile-label">Categories</div>
      <div className="col-md-10 profile-value">{(profile.categories || []).join(', ')}</div>
    </div>
  </div>
  );

ProfileSummary.propTypes = {
  profile: React.PropTypes.object.isRequired,
};

export default ProfileSummary;



// WEBPACK FOOTER //
// ./src/components/profile-summary/index.js